import React from 'react';
import { motion } from 'framer-motion';

const springEasing = [0.22, 1, 0.36, 1];

const stats = [
  { value: '2 400+', label: 'Fornøyde kunder', accent: '#FF5722' },
  { value: 'kr 48M+', label: 'Spart totalt i NOK', accent: '#004F98' },
  { value: '34%', label: 'Gjennomsnittlig besparelse', accent: '#FF5722' },
  { value: '99.8%', label: 'Kundetilfredshet', accent: '#004F98' },
];

const StoriesHero = () => {
  return (
    <section style={{ padding: '80px 24px 60px', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '64px', alignItems: 'center' }}>
        {/* Left: Text */}
        <motion.div
          initial={{ opacity: 0, x: -32 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, ease: springEasing }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
            <div style={{ width: '32px', height: '2px', background: '#FF5722' }} />
            <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#FF5722' }}>Suksesshistorier</span>
          </div>
          <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: '52px', fontWeight: 700, color: 'var(--color-foreground)', lineHeight: 1.1, letterSpacing: '-0.03em', marginBottom: '24px' }}>
            Ekte resultater fra
            <span style={{ display: 'block', color: '#FF5722' }}>norske bedrifter</span>
          </h1>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '17px', color: 'var(--color-muted-foreground)', lineHeight: 1.7, marginBottom: '36px', maxWidth: '480px' }}>
            Se hvordan norske transport- og logistikkselskaper bruker Veiassistent til å dramatisk redusere bomkostnader og optimalisere ruter over hele landet.
          </p>
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 16px', background: 'rgba(255,87,34,0.08)', border: '1px solid rgba(255,87,34,0.2)', borderRadius: '2px' }}>
              <div style={{ width: '8px', height: '8px', background: '#FF5722', borderRadius: '1px' }} />
              <span style={{ fontFamily: 'var(--font-heading)', fontSize: '12px', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', color: 'var(--color-foreground)' }}>Verifiserte resultater</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 16px', background: 'rgba(0,79,152,0.08)', border: '1px solid rgba(0,79,152,0.2)', borderRadius: '2px' }}>
              <div style={{ width: '8px', height: '8px', background: '#004F98', borderRadius: '1px' }} />
              <span style={{ fontFamily: 'var(--font-heading)', fontSize: '12px', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', color: 'var(--color-foreground)' }}>Norske kroner (NOK)</span>
            </div>
          </div>
        </motion.div>

        {/* Right: Stats grid */}
        <motion.div
          initial={{ opacity: 0, x: 32 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.15, ease: springEasing }}
          style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}
        >
          {stats?.map((stat, i) => (
            <motion.div
              key={stat?.label}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 + i * 0.08, duration: 0.5, ease: springEasing }}
              style={{
                background: 'rgba(255,255,255,0.03)',
                border: '1px solid rgba(224,228,232,0.08)',
                borderRadius: '2px',
                padding: '28px 24px',
                position: 'relative',
                overflow: 'hidden'
              }}
            >
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '2px', background: stat?.accent }} />
              <div style={{ fontFamily: 'var(--font-heading)', fontSize: '32px', fontWeight: 700, color: 'var(--color-foreground)', letterSpacing: '-0.02em', marginBottom: '8px', fontVariantNumeric: 'tabular-nums' }}>{stat?.value}</div>
              <div style={{ fontFamily: 'var(--font-caption)', fontSize: '12px', fontWeight: 500, color: 'var(--color-muted-foreground)', lineHeight: 1.4 }}>{stat?.label}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default StoriesHero;
